import { render, staticRenderFns } from "./edit-pass.vue?vue&type=template&id=6cb6bb1a&scoped=true&"
import script from "./edit-pass.vue?vue&type=script&lang=js&"
export * from "./edit-pass.vue?vue&type=script&lang=js&"
import style0 from "./edit-pass.vue?vue&type=style&index=0&id=6cb6bb1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb6bb1a",
  null
  
)

export default component.exports